import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=2ac32812&scoped=true"
import script from "./LogsTable.vue?vue&type=script&lang=js"
export * from "./LogsTable.vue?vue&type=script&lang=js"
import style0 from "../../components/dataIterator/TableCustomSort.scss?vue&type=style&index=0&id=2ac32812&prod&lang=scss&scoped=true&external"
import style1 from "../../components/dataIterator/DataIteratorFooter.scss?vue&type=style&index=1&id=2ac32812&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac32812",
  null
  
)

export default component.exports